import axios from "../../config/axiosConfig";
import {
  CREATE_GENERAL_PURCHASE_BILL, DELETE_GENERAL_PURCHASE_BILL,
  GENERAL_PURCHASE_BILL_REQUEST_SUCCESS,
  GET_GENERAL_PURCHASE_BILLS,
  GET_GENERAL_PURCHASE_BILLS_PAGE,
  GENERAL_PURCHASE_BILL_REQUEST,
  GENERAL_PURCHASE_BILL_REQUEST_FAILURE,
  UPDATE_GENERAL_PURCHASE_BILL
} from "../types/general-purchase-bill-types";

export const getGeneralPurchaseBillsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Account_Id,Expense_Account_Id'
      };
      return axios.get("/general-purchase-bill/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_GENERAL_PURCHASE_BILLS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
    }
  };
};


export const getGeneralPurchaseBills = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/general-purchase-bill/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_GENERAL_PURCHASE_BILLS, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getValidatedIncrementedVchNoGeneralPurchaseBill = (currentVchNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      
      const response = await axios.get("/general-purchase-bill/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getGeneralPurchaseBillsByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/general-purchase-bill/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getGeneralPurchaseBillById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST });
    
      return axios.get(`/general-purchase-bill/get/${id}`).then((response) => {
        dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST_FAILURE, error: error.message }); 
        throw error; 
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createGeneralPurchaseBill = (purchasebill) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST });
      const newPurchaseBill = {
        ...purchasebill
      };
      return axios.post("/general-purchase-bill/add", newPurchaseBill,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_GENERAL_PURCHASE_BILL, payload: response.data });
        } else {
          dispatch({
            type: GENERAL_PURCHASE_BILL_REQUEST_FAILURE,
            error: "General Purchase bill create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateGeneralPurchaseBill = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST });
      const { auth } = getState();
      return axios.put("/general-purchase-bill/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_GENERAL_PURCHASE_BILL,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: GENERAL_PURCHASE_BILL_REQUEST_FAILURE,
            error: "General Purchase bill update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteGeneralPurchaseBill = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST });
      return axios.delete(`/general-purchase-bill/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_GENERAL_PURCHASE_BILL, id: id });
          const include = ['id', 'Entry_No', 'Bill_No', 'Date', 'Account_Id', 'Expense_Account_Id', 'Bill_Status', 'Invoice_Type', 'Amount', 'Net_Total'].join(',');
          const searchCols = ['Entry_No'].join(',');
          const { inventory: { generalPurchaseBill: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getGeneralPurchaseBillsWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GENERAL_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};